module.exports = require("remarkable");


//////////////////
// WEBPACK FOOTER
// external "remarkable"
// module id = 262
// module chunks = 0